import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBKUf7yDfxo7i8s82-Tklub_sbi8eqWyhQ",
  authDomain: "teaich-app.firebaseapp.com",
  projectId: "teaich-app",
  storageBucket: "teaich-app.firebasestorage.app",
  messagingSenderId: "658564593877",
  appId: "1:658564593877:web:17ba972b660ea81c7e4a5c"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;